import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../api/client'

export function useWorkshopParts() {
  return useQuery({ queryKey: ['parts'], queryFn: api.listWorkshopParts })
}

/**
 * Teil in der Bestell-Pipeline weiterschalten (needed→ordered→delivered→installed, oder einen Schritt zurück
 * bei Fehlklick). Schreibt über PATCH parts/:id; bei Erfolg die Einkaufsliste neu laden. Der Endpunkt liefert
 * das Auftrags-Detail zurück (Teile hängen am Auftrag) — das interessiert das Board nicht, darum invalidieren
 * wir nur ['parts'].
 */
export function useAdvancePart() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (vars: { partId: number; status: string }) => api.patchPart(vars.partId, { status: vars.status }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['parts'] }),
  })
}
